<template>
  <div class="banner-about">
    <div class="container">
      <div class="banner-about-wrap">
        <div class="banner-about-title">
          Организаторы SPACE EVENT
        </div>
        <div class="banner-about-text">
          Инновационная экосистема, соединяющая человеческий капитал с целью эволюции. Пространство, где есть все
          необходимое для личностного и духовного роста.
        </div>
        <div class="banner-about-logos">
          <div class="row align-items-center justify-content-center">
            <div class="col-5 col-sm-auto mb-1">
              <img class="img-fluid" :src="require(`@/assets/logos/ELSSPACE-about.svg`)">
            </div>
            <div class="col-2 col-sm-auto mb-1">
              <img class="img-fluid" :src="require(`@/assets/logos/&-about.svg`)">
            </div>
            <div class="col-5 col-sm-auto mb-1">
              <img class="img-fluid" style="height: 60px" :src="require(`@/assets/logo-2-3.svg`)">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BannerAbout"
}
</script>

<style lang="scss" scoped>
.banner-about-wrap {
  border-radius: 16px;
  background: linear-gradient(114deg, rgba(1, 203, 216, 0.80) -11.51%, rgba(20, 0, 255, 0.80) 25.36%, rgba(0, 5, 30, 0.80) 110.23%), #000;
  box-shadow: 0px 4px 76px 0px rgba(0, 0, 0, 0.60);
  padding: 16px 16px 36px 16px;
  margin-top: 60px;
  @include _768 {
    padding: 40px 60px;
    margin-top: 120px;
  }

  .banner-about-title {
    color: var(--white, #FFF);
    font-family: Play, serif;
    font-size: 26px;
    font-style: normal;
    font-weight: 700;
    line-height: 138%; /* 35.88px */
    margin-bottom: 8px;
    @include _768 {
      font-size: 38px;
      margin-bottom: 30px;
      text-align: center;
    }
  }

  .banner-about-text {
    color: var(--gray, #C7C7D1);
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 136%; /* 21.76px */
    margin-bottom: 30px;
    @include _768 {
      color: var(--white, #FFF);
      font-size: 22px;
      text-align: center;
    }
  }
}
</style>